import { useMemo } from 'react';
import { TransferQueueTable } from '../../components/custodian/TransferQueueTable';

/**
 * Custody, control and assignment transfers (BRD EV-17..EV-22).
 * The system locks the authority version at instruction time; the custodian
 * accepts the manifest under the programme mandate and then commits, which
 * writes the next authority version and a hashed receipt.
 */
export function TransferQueuePage() {
  const types = useMemo(() => ['CUSTODY', 'CONTROL', 'ASSIGNMENT'], []);
  return (
    <TransferQueueTable
      title="Transfer transactions"
      types={types}
      intro="Custody, control and assignment transfers. Each row is locked to one authority version; open the manifest to see what changes and what stays before accepting. Commit writes the next authority version and issues the receipt."
      emptyMessage="No custody, control or assignment transfers."
    />
  );
}
